import {showErrorNotification} from "../../global/notifications";

export default function () {
    attachCreateScheduleFiveEvent();
}

const attachCreateScheduleFiveEvent = () => {
    const $createButton = $('.js-create-schedule-5');
    if ($createButton.length) {
        $createButton.bind('click', function () {
            const $this = $(this);
            $this.attr('disabled', true);
            createScheduleFive()
                .then(_ => $('form').submit())
                .catch(error => {
                    showErrorNotification(error);
                    $this.attr('disabled', false);
                })
        })
    }
}

const createScheduleFive = () => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/ScheduleFive/CreateScheduleFive', {pid: $('[name=pid]').val()}, function (response) {
            if (response && response.success) resolve();
            else reject(response.message);
        });
    })
}